var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://lgog3cuuqji.sg.larksuite.com/share/base/form/shrlgMw6Au2VkCi0ZLKfnw6aOXc","title":"description"}})
}
var staticRenderFns = []

export { render, staticRenderFns }